import React from 'react';
import * as Styled from './MetaList.styled';
import { MetaListItem } from '../MetaListItem/MetaListItem';
import type { MetaListProps } from './MetaList.typed';

const MetaList = React.forwardRef<HTMLUListElement, MetaListProps>(
  (props, ref) => {
    const { listItems, variant = 'DEFAULT' } = props;

    return (
      <Styled.MetaList ref={ref}>
        {listItems.map(
          (item, index) =>
            item && (
              <MetaListItem key={index} variant={variant}>
                {item}
              </MetaListItem>
            ),
        )}
      </Styled.MetaList>
    );
  },
);

MetaList.displayName = 'MetaList';

export { MetaList };
